"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMPT_TYPE = void 0;
var PROMPT_TYPE;
(function (PROMPT_TYPE) {
    PROMPT_TYPE["SUMMARY"] = "summary";
    PROMPT_TYPE["MULTIPLE_CHOICE"] = "multiple_choice";
    PROMPT_TYPE["WORDFILL_FACTS"] = "wordfill_facts";
    PROMPT_TYPE["WORDFILL_QUESTIONS"] = "wordfill_questions";
    PROMPT_TYPE["TRANSCRIPT_TO_RESOURCE_TEXT"] = "transcript_to_resource_text";
})(PROMPT_TYPE = exports.PROMPT_TYPE || (exports.PROMPT_TYPE = {}));
//# sourceMappingURL=Prompts.js.map